import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeedbacks, deleteFeedback } from '../../../store/feedbackSlice';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../Styles/Common.css';

const ICTFeedbacks = () => {
    const dispatch = useDispatch();
    const { feedbacks, loading } = useSelector((state) => state.feedbacks);

    const [searchFilters, setSearchFilters] = useState({
        ictId: '',
        learnerId: '',
    });

    const [sortBy, setSortBy] = useState('date'); // Default sort by date

    useEffect(() => {
        dispatch(fetchFeedbacks());
    }, [dispatch]);

    const handleDeleteFeedback = async (id) => {
        if (window.confirm('Are you sure you want to delete this feedback?')) {
            try {
                await dispatch(deleteFeedback(id)).unwrap();
                toast.success('Feedback deleted successfully!');
            } catch {
                toast.error('Failed to delete feedback.');
            }
        }
    };

    const filteredFeedbacks = feedbacks
        .filter(
            (feedback) =>
                (!searchFilters.ictId || feedback.ictId_id.toString() === searchFilters.ictId) &&
                (!searchFilters.learnerId || feedback.learnerId_id.toString() === searchFilters.learnerId)
        )
        .sort((a, b) => {
            if (sortBy === 'rating') {
                return b.feedbackRating - a.feedbackRating;
            } else {
                return new Date(b.feedbackDateTime) - new Date(a.feedbackDateTime);
            }
        });

    return (
        <div className="ict-feedbacks-container">
            <h3 className="ict-feedbacks-title">ICT Feedbacks</h3>
            <div className="feedback-filters">
                <input
                    type="number"
                    placeholder="Search by ICT ID"
                    value={searchFilters.ictId}
                    onChange={(e) => setSearchFilters({ ...searchFilters, ictId: e.target.value })}
                    className="filter-input"
                />
                <input
                    type="number"
                    placeholder="Search by Learner ID"
                    value={searchFilters.learnerId}
                    onChange={(e) => setSearchFilters({ ...searchFilters, learnerId: e.target.value })}
                    className="filter-input"
                />
                <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="filter-select"
                >
                    <option value="date">Sort by Date</option>
                    <option value="rating">Sort by Rating</option>
                </select>
            </div>

            {loading ? (
                <p>Loading feedbacks...</p>
            ) : (
                <table className="feedbacks-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Message</th>
                            <th>Trainer</th>
                            <th>Rating</th>
                            <th>Date</th>
                            <th>ICT ID</th>
                            <th>Learner ID</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredFeedbacks.map((feedback, index) => (
                            <tr key={feedback.id}>
                                <td>{index + 1}</td>
                                <td>
                                    {feedback.feedbackMsg.length > 250 ? (
                                        <>
                                            {feedback.feedbackMsg.slice(0, 250)}...
                                            <span className="read-more">Read More</span>
                                        </>
                                    ) : (
                                        feedback.feedbackMsg
                                    )}
                                </td>
                                <td>{feedback.feedbackTrainer}</td>
                                <td>{feedback.feedbackRating}</td>
                                <td>{moment(feedback.feedbackDateTime).format('DD:MM:YYYY hh:mm:ss')}</td>
                                <td>{feedback.ictId_id}</td>
                                <td>{feedback.learnerId_id}</td>
                                <td>
                                    <i
                                        className="fa fa-trash action-icon deleteIcon"
                                        onClick={() => handleDeleteFeedback(feedback.id)}
                                    ></i>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <ToastContainer position="bottom-right" autoClose={3000} />
        </div>
    );
};

export default ICTFeedbacks;
